import { useEffect, useState } from "react";
import { useAdmin } from "../../context/AdminContext";
import { FiRefreshCw } from "react-icons/fi";
import "./Admin.css";
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  Tooltip,
  ResponsiveContainer,
} from "recharts";
import { useNavigate } from "react-router-dom";

const AdminDashboard = () => {
  const navigate = useNavigate();
  const [lastUpdated, setLastUpdated] = useState(null);
  const {
    sessions,
    fetchAllSessions,
    loadAnalytics,
    totalUsers,
    activeUsers,
    dailyUsers,
    timeSpent,
    fetchUserSessions,
    clearUserSessions,
    feedbacks,
    feedbackLoading,
    feedbackError,
    fetchAllFeedbacks,
    usersStatus,
    usersStatusLoading,
    fetchUsersStatus,
    updateUserAccountStatus,

    updateFeedbackStatus,
    feedbackStatusLoadingId,
    feedbackStatusError,
  } = useAdmin();

  // useEffect(() => {
  //   fetchAllSessions();
  //   loadAnalytics();
  //   fetchAllFeedbacks();
  //   fetchUsersStatus();
  // }, []);
  useEffect(() => {
    const loadDashboard = async () => {
      try {
        await Promise.allSettled([
          fetchAllSessions(),
          loadAnalytics(),
          fetchAllFeedbacks(),
          fetchUsersStatus(),
        ]);
      } catch (err) {
        console.error("Dashboard load failed:", err);
      }
    };

    loadDashboard();
  }, []);

  console.log("Sessions", sessions);
  console.log(
    "All users function result",
    totalUsers,
    activeUsers,
    dailyUsers,
    timeSpent,
  );
  const avgTime =
    timeSpent?.length > 0
      ? (timeSpent.reduce((a, b) => a + b, 0) / timeSpent.length / 60).toFixed(
          1,
        )
      : 0;

  // const handleRefresh = () => {
  //   fetchAllSessions();
  //   loadAnalytics();
  // };
  const handleRefresh = async () => {
    await Promise.allSettled([
      fetchAllSessions(),
      loadAnalytics(),
      fetchAllFeedbacks(),
      fetchUsersStatus(),
    ]);

    setLastUpdated(formatTimestamp());
  };

  const formatTimestamp = () => {
    const now = new Date();

    const day = String(now.getDate()).padStart(2, "0");

    const monthNames = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ];
    const month = monthNames[now.getMonth()];
    const year = now.getFullYear();

    const time = now.toLocaleTimeString("en-IN", {
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      hour12: false,
    });

    return `${day}-${month}-${year} ${time} IST`;
  };
  useEffect(() => {
    if (sessions?.length) {
      setLastUpdated(formatTimestamp());
    }
  }, [sessions]);
  const handleReview = (item) => {
    console.log("Review:", item);
    // 👉 open modal or mark reviewed
  };

  const handleClose = (item) => {
    console.log("Close:", item);
    // 👉 update DB status later
  };

  console.log("USR STATUS", usersStatus);
  const userStatusMap = new Map(usersStatus.map((user) => [user.userID, user]));
  const handleFeedbackStatus = async (item, newStatus) => {
    const result = await updateFeedbackStatus(item.id, newStatus);

    if (!result?.success) {
      console.error(result?.message || "Failed to update feedback");
      return;
    }

    console.log(result.message);
  };
  return (
    <>
      <div
        className="last-updated-head"
        style={{
          display: "flex",
          alignItems: "center",
          gap: "10px",
          fontSize: "13px",
          color: "#6b7280",
          // marginTop: "10px",
          // marginBottom: "10px",
        }}
      >
        {lastUpdated && <span>As on {lastUpdated}</span>}

        <FiRefreshCw
          size={16}
          onClick={handleRefresh}
          style={{
            cursor: "pointer",
            transition: "0.2s",
          }}
          onMouseOver={(e) => (e.target.style.color = "#2fd18a")}
          onMouseOut={(e) => (e.target.style.color = "#6b7280")}
        />
      </div>
      <div>
        <h2 className="admin-head">Admin Dashboard</h2>
        <div style={{ display: "flex", gap: "20px", marginBottom: "20px" }}>
          <div className="card">
            <h4>Total Users</h4>
            <p>{totalUsers}</p>
          </div>

          <div className="card">
            <h4>Active Users</h4>
            <p style={{ color: "#16a34a" }}>{activeUsers}</p>
          </div>

          <div className="card">
            <h4>Avg Time Spent</h4>
            <p>{avgTime} mins</p>
          </div>
        </div>
        <div style={{ width: "100%", height: 300, marginBottom: "30px" }}>
          <h3>Daily Active Users</h3>

          <ResponsiveContainer>
            <LineChart data={dailyUsers}>
              <XAxis dataKey="date" />
              <YAxis />
              <Tooltip />
              <Line type="monotone" dataKey="users" />
            </LineChart>
          </ResponsiveContainer>
        </div>

        <div className="stock-table-container">
          <div className="stock-responsive-table">
            <table className="stock-table ">
              <thead>
                <tr>
                  <th>User</th>
                  <th>Login Time</th>
                  <th>Logout Time</th>
                  <th>Account Status</th>
                  <th>Status</th>
                  <th>Duration</th>
                </tr>
              </thead>

              <tbody>
                {sessions?.map((session) => {
                  const login = new Date(session.login_at);
                  const logout = session.logout_at
                    ? new Date(session.logout_at)
                    : null;

                  const duration = logout
                    ? ((logout - login) / 1000 / 60).toFixed(1) + " min"
                    : "Running...";
                  const account = userStatusMap.get(session.UserID);

                  const isDeactivate = account?.isDeactivate ?? false;
                  return (
                    <tr
                      key={session.id}
                      className="stock-row"
                      onClick={() => navigate(`/admin/user/${session.UserID}`)}
                    >
                      {/* USER */}
                      <td>{session.UserID}</td>

                      {/* LOGIN TIME */}
                      <td>{login.toLocaleString()}</td>

                      {/* LOGOUT TIME */}
                      <td>{logout ? logout.toLocaleString() : "—"}</td>

                      <td>
                        <button
                          className="rec-btn"
                          style={{
                            color: isDeactivate ? "#249966" : "#dc2626",
                            fontWeight: "bold",
                          }}
                          onClick={(e) => {
                            e.stopPropagation();

                            updateUserAccountStatus(
                              session.UserID,
                              !isDeactivate,
                            );
                          }}
                        >
                          {isDeactivate ? "🟢 Activate" : "🔴 Deactivate"}
                        </button>
                      </td>

                      {/* STATUS */}
                      <td>
                        <span
                          style={{
                            color: session.logout_at ? "#f87171" : "#249966",
                            fontWeight: "bold",
                          }}
                        >
                          {session.logout_at ? "Logged Out" : "🟢 Active"}
                        </span>
                      </td>

                      {/* DURATION */}
                      <td
                        style={{
                          fontWeight: "bold",
                          color: session.logout_at ? "#249966" : "#facc15",
                        }}
                      >
                        {duration}
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        </div>

        {/* <div className="stock-table-container" style={{ marginTop: "30px" }}>
          <h2 className="stocktest-h1">User Feedback</h2>

          <div className="stock-responsive-table">
            <table className="stock-table">
              <thead>
                <tr>
                  <th>Name</th>
                  <th>Email</th>
                  <th>Description</th>
                  <th>Date</th>
                  <th>Action</th>
                </tr>
              </thead>

              <tbody>
                {feedbacks?.map((item) => (
                  <tr key={item.id} className="stock-row">
                   
                    <td>
                      {item.FirstName} {item.LastName}
                    </td>

                   
                    <td>{item.Email}</td>

                    
                    <td style={{ maxWidth: "300px" }}>
                      {item.Description.length > 80
                        ? item.Description.slice(0, 80) + "..."
                        : item.Description}
                    </td>

                   
                    <td>{new Date(item.created_at).toLocaleString()}</td>
                    <td>
                      <div className="feedback-action-dropdown">
                        <button className="rec-btn action-btn">Action ⬇</button>

                        <div className="feedback-action-menu">
                          <div
                            className="feedback-action-item"
                            onClick={() => handleReview(item)}
                          >
                            Review
                          </div>

                          <div
                            className="feedback-action-item"
                            onClick={() => handleClose(item)}
                          >
                            Close
                          </div>
                        </div>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div> */}
        <div className="stock-table-container" style={{ marginTop: "30px" }}>
          <h2 className="stocktest-h1">User Feedback</h2>

          {feedbackLoading && (
            <p className="feedback-message">Loading feedbacks...</p>
          )}

          {feedbackError && <p className="feedback-error">{feedbackError}</p>}

          {feedbackStatusError && (
            <p className="feedback-error">{feedbackStatusError}</p>
          )}

          {!feedbackLoading && !feedbackError && feedbacks?.length === 0 && (
            <p className="feedback-message">No feedback found.</p>
          )}

          {!feedbackLoading && feedbacks?.length > 0 && (
            <div className="stock-responsive-table">
              <table className="stock-table">
                <thead>
                  <tr>
                    <th>Name</th>
                    <th>Email</th>
                    <th>Description</th>
                    <th>Submitted At</th>
                    <th>Status</th>
                    <th>Resolved At</th>
                    <th>Action</th>
                  </tr>
                </thead>

                <tbody>
                  {feedbacks.map((item) => {
                    const status = item.status || "open";

                    const isUpdating =
                      String(feedbackStatusLoadingId) === String(item.id);

                    return (
                      <tr key={item.id} className="stock-row">
                        <td>
                          {item.FirstName || ""} {item.LastName || ""}
                        </td>

                        <td>{item.Email || "—"}</td>

                        <td style={{ maxWidth: "300px" }}>
                          {item.Description
                            ? item.Description.length > 80
                              ? `${item.Description.slice(0, 80)}...`
                              : item.Description
                            : "No description"}
                        </td>

                        <td>
                          {item.created_at
                            ? new Date(item.created_at).toLocaleString(
                                "en-IN",
                                {
                                  timeZone: "Asia/Kolkata",
                                  day: "2-digit",
                                  month: "short",
                                  year: "numeric",
                                  hour: "2-digit",
                                  minute: "2-digit",
                                  hour12: true,
                                },
                              )
                            : "—"}
                        </td>

                        <td>
                          <span
                            className={`feedback-status ${
                              status === "resolved"
                                ? "feedback-status-resolved"
                                : "feedback-status-open"
                            }`}
                          >
                            {status === "resolved" ? "Resolved" : "Open"}
                          </span>
                        </td>

                        <td>
                          {item.resolved_at
                            ? new Date(item.resolved_at).toLocaleString(
                                "en-IN",
                                {
                                  timeZone: "Asia/Kolkata",
                                  day: "2-digit",
                                  month: "short",
                                  year: "numeric",
                                  hour: "2-digit",
                                  minute: "2-digit",
                                  hour12: true,
                                },
                              )
                            : "—"}
                        </td>

                        <td>
                          {status === "resolved" ? (
                            <button
                              type="button"
                              className="rec-btn feedback-reopen-btn"
                              disabled={isUpdating}
                              onClick={() => handleFeedbackStatus(item, "open")}
                            >
                              {isUpdating ? "Reopening..." : "Reopen"}
                            </button>
                          ) : (
                            <button
                              type="button"
                              className="rec-btn feedback-resolve-btn"
                              disabled={isUpdating}
                              onClick={() =>
                                handleFeedbackStatus(item, "resolved")
                              }
                            >
                              {isUpdating ? "Updating..." : "Mark Resolved"}
                            </button>
                          )}
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default AdminDashboard;
